"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnexSheets = void 0;
const lodash_1 = require("lodash");
const annexSheet_1 = require("./annexSheet");
/**
 * Fiches annexes formatées d'un bilan
 * @document ../process/newAnnexSheet.md
 */
class AnnexSheets {
    constructor(annexSheets) {
        this.annex_sheets = annexSheets.map(as => new annexSheet_1.AnnexSheetImpl(as));
        this.annex_sheets_grouped = (0, lodash_1.groupBy)(this.annex_sheets, `kind`);
        for (const annexSheetsKey in this.annex_sheets_grouped) {
            if (this.annex_sheets_grouped[annexSheetsKey].length > 1) {
                this.annex_sheets_grouped[annexSheetsKey] = this.annex_sheets_grouped[annexSheetsKey].sort((a, b) => b['created_at_luxon'].toMillis() < a['created_at_luxon'].toMillis()
                    ? -1
                    : b['created_at_luxon'].toMillis() > a['created_at_luxon'].toMillis()
                        ? 1
                        : 0);
            }
        }
    }
    /**
     * Retourne la dernière fiche annexe d'une catégorie.
     * @param {SyoApi.AnnexSheetKindType} property - Clé de la catégorie voulue
     * @return {SyoLib.AnnexSheet | null}
     */
    getLastSheet(property) {
        return this.annex_sheets_grouped[property][0] || null;
    }
}
exports.AnnexSheets = AnnexSheets;
